import { create } from 'zustand';

/** De onde a sacola foi aberta — vai no `cart_viewed`. */
export type OrigemDaSacola = 'cabecalho' | 'faixa' | 'produto';

interface CartPanelState {
  aberta: boolean;
  /**
   * A origem da ÚLTIMA abertura.
   *
   * Existe porque `cart_viewed` só sabia dizer que a gaveta foi vista, e são
   * três os caminhos até ela. Sem isto, tirar a faixa do ar não teria como ser
   * avaliado: as aberturas dela e as do ícone do topo eram o mesmo número.
   */
  origem: OrigemDaSacola | null;
  abrir: (origem: OrigemDaSacola) => void;
  fechar: () => void;
  setAberta: (aberta: boolean) => void;
}

/**
 * Estado de abertura da sacola.
 *
 * Store, e não `useState` no `CartButton`, porque QUEM abre a sacola não é só o
 * botão do cabeçalho: a página de produto abre quando a peça já está lá, e o
 * mesmo vale para qualquer atalho futuro. Com o estado no botão, cada um desses
 * pontos teria de subir um callback por toda a árvore.
 *
 * Sem `persist`, ao contrário do carrinho do catálogo de kits: aqui não há dado
 * nenhum, só "o painel está aberto". Reabrir sozinho depois de um F5 seria uma
 * gaveta que a pessoa não pediu.
 */
export const useCartPanel = create<CartPanelState>((set) => ({
  aberta: false,
  origem: null,
  abrir: (origem) => set({ aberta: true, origem }),
  fechar: () => set({ aberta: false }),
  setAberta: (aberta) => set({ aberta }),
}));
